import React from "react";
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';

const propTypes = {
  metadata: PropTypes.shape({
    title: PropTypes.string,
    meta: PropTypes.array,
    link: PropTypes.array,
  })
};

const defaultProps = {
  metadata: {
    title: null,
    meta: [],
    link: [],
  }
};

class Metadata extends React.Component {

  render() {
    const { title, meta, link } = this.props.metadata;

    if(!title) return null;

    return (
      <Helmet
        title={ title }
        meta={ meta }
        link={ link }
      />
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  return {
    metadata: state.metadata.data
  };
};

Metadata.propTypes = propTypes;
Metadata.defaultProps = defaultProps;

export default connect(mapStateToProps)(Metadata);
